module.exports = __webpack_public_path__ + "static/media/logo.4acfda67.png";